import React from "react";
import {Button} from "antd";
import {TeamOutlined} from "@ant-design/icons";
import {
  canManageCollectorBands,
  summarizeProfileBands,
  toProfiles,
} from "./collectorProfileView";

const CollectorBandCell = ({auth, rowData, onManage}) => (
  <span>
    {summarizeProfileBands(toProfiles(rowData))}
    {canManageCollectorBands(auth) &&
      <Button
        aria-label="소속 밴드 관리"
        type={`primary`}
        shape={`circle`}
        size={`small`}
        style={{marginLeft: `8px`}}
        onClick={() => onManage(rowData)}
        icon={<TeamOutlined/>}/>
    }
  </span>
);

export default CollectorBandCell;
